import { useState } from "react"
import { uploadKnowledge, createLinkKnowledge } from "@/api/kuizy"
import { Upload, Loader2 } from "lucide-react"

export default function UploadPanel({ lessonId, refresh }) {
    const [uploading, setUploading] = useState(false)
    const [link, setLink] = useState("")
    const [loadingLink, setLoadingLink] = useState(false)

    const handleUpload = async (e) => {
        const file = e.target.files[0]
        if (!file) return

        const formData = new FormData()
        formData.append("lesson_id", lessonId)
        formData.append("file", file)

        setUploading(true)
        await uploadKnowledge(formData)
        setUploading(false)
        refresh()
    }

    const handleAddLink = async () => {
        if (!link.trim()) return

        try {
            setLoadingLink(true)

            await createLinkKnowledge({
                lesson_id: lessonId,
                link: link.trim()
            })

            setLink("")
            refresh()

        } catch (err) {
            console.error(err)
            alert("เพิ่มลิงก์ไม่สำเร็จ")
        } finally {
            setLoadingLink(false)
        }
    }


    return (
        <div className="bg-white border rounded-2xl p-6 shadow-sm space-y-5">

            <h2 className="font-semibold">เพิ่มเนื้อหา</h2>

            <label className="border-2 border-dashed rounded-xl p-6 flex flex-col items-center cursor-pointer hover:bg-gray-50">
                {uploading ? (
                    <Loader2 className="animate-spin" />
                ) : (
                    <>
                        <Upload size={24} />
                        <span className="text-sm mt-2">อัปโหลดไฟล์</span>
                    </>
                )}
                <input type="file" className="hidden" onChange={handleUpload} />
            </label>

            <div className="space-y-2">
                <input
                    value={link}
                    onChange={(e) => setLink(e.target.value)}
                    placeholder="วางลิงก์ YouTube หรือ URL"
                    className="border rounded-lg px-3 py-2 w-full text-sm"
                />
                <button
                    onClick={handleAddLink}
                    className="bg-pink-500 text-white w-full py-2 rounded-lg"
                >
                    {loadingLink ? "กำลังเพิ่ม..." : "เพิ่มลิงก์"}
                </button>
            </div>

        </div>
    )
}
